import { IConfig as IUnleashConfig, UnleashClient } from 'unleash-proxy-client';

let unleashClient: UnleashClient | null = null;

export const initializeUnleashClient = async (config: IUnleashConfig): Promise<UnleashClient> => {
  if (unleashClient) return unleashClient;
  unleashClient = new UnleashClient(config);
  await unleashClient.start();
  return unleashClient;
};

export const getUnleashClient = (): UnleashClient | null => unleashClient;
